import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IConfrontarDigitaisIIRGDState } from './types';

export const INITIAL_STATE: IConfrontarDigitaisIIRGDState = {
	qtdeFalha: 0,
	resultado: false,
	dedo: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IConfrontarDigitaisIIRGDState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONFRONTAR_DIGITAIS_IIRGD_REQUEST: {
				draft.dedo = action.payload.posicaoDedo;
				break;
			}
			case Types.CONFRONTAR_DIGITAIS_IIRGD_SUCCESS: {
				draft.qtdeFalha = 0;
				draft.resultado = true;
				break;
			}
			case Types.CONFRONTAR_DIGITAIS_IIRGD_FAILURE: {
				draft.qtdeFalha += 1;
				draft.resultado = false;
				break;
			}
			case Types.CONFRONTAR_DIGITAIS_IIRGD_CLEAR: {
				draft.qtdeFalha = INITIAL_STATE.qtdeFalha;
				draft.resultado = INITIAL_STATE.resultado;
				draft.dedo = INITIAL_STATE.dedo;
				break;
			}

			default:
		}
		return draft;
	});
}
